<template>
    <div class="p-2 bg-white dark:bg-slate-800">
        <div class="flex flex-wrap mx-2">
            <div class="w-full inline-flex items-center px-3" :class="{ 'justify-end': this.end == 'true' }">
                <div class="flex flex-row flex-auto">
                    <slot name="pre-custom">

                    </slot>
                </div>
                <custom-button v-if="buttons.cancel && hasCancel" predefinedStyle="transparentLight" :loading="isCanceling"
                    @button:click="$emit('button:' + this.cancel)">
                    <template v-slot:label>
                        <slot name="cancel">
                            <span class="mr-2" v-if="!isCanceling">
                                <i class="fas fa-times"></i>
                            </span>
                            <span>
                                {{ __('labels.basics.cancel') }}
                            </span>
                        </slot>
                    </template>
                </custom-button>

                <custom-button :class="{'opacity-70' : !dirty}" v-if="buttons.save" predefinedStyle="default" @button:click="$emit('button:' + this.save)" :loading="statusSaving"
                    css="ml-4 flex">
                    <template v-slot:label>
                        <slot name="save">
                            <span class="mr-2" v-if="!statusSaving">
                                <i class="fas fa-save"></i>
                            </span>
                            <span>
                                {{ __('labels.basics.save') }}
                            </span>
                        </slot>
                    </template>
                </custom-button>
                <div class="flex flex-row"  :class="{'w-full' : !end}">
                    <slot name="post-custom">

                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isDirty } from './useSaveLeave';
export default {
    props: {
        cancel: {
            type: String,
            default: "cancel",
        },
        save: {
            type: String,
            default: "save",
        },
        isSaving: {
            type: Boolean,
            default: false,
        },
        isCanceling: {
            type: Boolean,
            default: false,
        },
        end: {
            type: [String, Boolean],
            default: false,
        },
        hasCancel: {
            type: Boolean,
            default: true,
        },
        menu :{
            type : String,
            default : "down",
        }
    },
    setup(){
        const dirty = isDirty();
        return {
            dirty,
        }
    },
    data() {
        return {
            saving : false,
            buttons: {
                cancel : false,
                save : false,
            }
        };
    },

    computed: {
        statusSaving(){
            if(this.isSaving | this.saving){
                return true;
            }
            return false;
        }

    },
    mounted(){
        if(this.end == false){
            this.emitter.on("keypress:ctrl:s", (event) => {
                if(this.buttons.save){
                    this.$emit('button:' + this.save)
                }
            });
        }
        this.emitter.on('cancel-save-button:load', (event) => {
            this.saving = event;
        });
        this.emitter.on("cancel-save-button:buttons", (event) => {
            this.buttons[event.type] = event.value;
        })
    },
    unmounted(){
        this.emitter.off("keypress:ctrl:s");
        this.emitter.off('cancel-save-button:load');
        this.emitter.off("cancel-save-button:buttons");
    }
};
</script>
